<template>
  <label class="a-checkbox" :class="{ end: !leftToRight }">
    <input
      class="a-checkbox__input"
      type="checkbox"
      :value="value"
      :checked="checked"
      :disabled="disabled"
      @change="(e) => changeValue(e)"
    />
    <span class="a-checkbox__mark"></span>
    {{ title ?? '' }}
    <slot></slot>
  </label>
</template>

<script setup>
const props = defineProps({
  modelValue: null,
  value: null,
  title: String,
  disabled: {
    type: Boolean,
    default: false,
  },
  checked: {
    type: Boolean,
    default: false,
  },
  leftToRight: {
    type: Boolean,
    require: false,
    default: true,
    description: 'Direction of checkbox',
  },
  multiple: {
    type: Boolean,
    default: false,
    require: false,
    description: 'Target to multiple select',
  },
});

const emit = defineEmits(['update:modelValue']);

const changeValue = ($event) => {
  if (props.multiple) {
    // eslint-disable-next-line
    let updatedValue = [...props.modelValue];
    if (!props.checked) {
      updatedValue.push(props.value);
    } else {
      updatedValue.splice(updatedValue.indexOf(props.value), 1);
    }
    emit('update:modelValue', updatedValue);
  } else {
    emit('update:modelValue', $event.target.checked);
  }
};
</script>
